import React, { useContext, useEffect } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { BackButton } from '../../components/BackButton';
import { ApplicationFormStateContext } from '../../state/applicationFormState';
import { trackEvent } from '../../utils/gtm';
import { scrollToTopOfContent } from '../../utils/scroll';
import { useNavigate } from 'react-router-dom';
import { Step } from '../../models/Step';

const IncomeStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const { monthlyIncomeGross, monthlyIncomeNet } = state;
  const navigation = useNavigate();

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Income' } });
    dispatch({ type: 'set_step', step: Step.Income });
    scrollToTopOfContent();
  }, []);

  const validationSchema = yup.object().shape({
      monthlyIncomeGross: yup
        .number()
        .typeError('Indtast indkomst før skat')
        .min(0, 'Indtast indkomst før skat')
        .max(999999, 'Indtast indkomst før skat')
        .required('Indtast indkomst før skat'),
      monthlyIncomeNet: yup
        .number()
        .typeError('Indtast udbetalt pr. måned')
        .min(0, 'Indtast udbetalt pr. måned')
        .max(999999, 'Indtast udbetalt pr. måned')
        .required('Indtast udbetalt pr. måned')
  });

  return (
    <>
      <h2>Din personlige indkomst</h2>
      
      <Formik
        initialValues={{ monthlyIncomeGross, monthlyIncomeNet }}
        onSubmit={async (values) => {

          dispatch({
            type: 'set_income',
            monthlyIncomeGross: values.monthlyIncomeGross,
            monthlyIncomeNet: values.monthlyIncomeNet
          });
          
          navigation('/udgifter');

        }}
        validationSchema={validationSchema}
      >
        {(formikProps) => (
          <div className="mt-5">
            <div>
              <label className="label-default">Indkomst før skat pr. måned</label>
              <input
                type="text"
                name="monthlyIncomeGross"
                placeholder="Indkomst før skat pr. måned skal angives"
                defaultValue={formikProps.values.monthlyIncomeGross}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />
              
              {(formikProps.touched.monthlyIncomeGross ||
                formikProps.submitCount > 0) &&
                formikProps.errors.monthlyIncomeGross && (
                  <div className="invalid-feedback">
                    {formikProps.errors.monthlyIncomeGross}
                  </div>
                )}
            </div>

            <div className="mt-5">
              <label className="label-default">Udbetalt pr. måned</label>
              <input
                type="text"
                name="monthlyIncomeNet"
                placeholder="Indkomst efter skat pr. måned skal angives"
                defaultValue={formikProps.values.monthlyIncomeNet}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />

              {(formikProps.touched.monthlyIncomeNet ||
                formikProps.submitCount > 0) &&
                formikProps.errors.monthlyIncomeNet && (
                  <div className="invalid-feedback">
                    {formikProps.errors.monthlyIncomeNet}
                  </div>
                )}
            </div>

            <div className="container-btn">
              <BackButton />

              <button
                className="btn btn-next"
                type="submit"
                onClick={() => formikProps.submitForm()}
              >
                Næste
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default IncomeStep;
